export default "__VITE_ASSET__DMuq0R1E__"